module.exports = __webpack_public_path__ + "img/teamRaiders.acb4ee3b.jpg";